export default {
  plan: 'Plan',
  continue: 'Continuar',
  docs: 'Documentación',
  assistViaEmail: 'Estaremos encantados de ayudarle por correo electrónico.',
  sendFeedback: 'Por favor envíe sus preguntas y comentarios a',
  howDoISignUp: '¿Cómo me registro?',
  requiredName: 'El nombre es un campo obligatorio',
  requiredEmail: 'El correo electrónico es un campo obligatorio',
  requiredPassword: 'La contraseña es un campo obligatorio',
  invalidEmail: 'El correo electrónico no es válido',
  minLengthPassword: 'La contraseña debe contener 8 letras o dígitos',
  invalidPassword:
    'La contraseña debe contener una letra mayúscula, una letra minúscula, un número y un carácter especial',
  getStartedWorkoutPlanEmailReminder:
    'Para empezar, simplemente visite la página web de Fit4Me y responda algunas preguntas rápidas sobre sus preferencias de entrenamiento y nutrición, objetivos y nivel de condición física. También le pediremos su correo electrónico: asegúrese de haberlo introducido correctamente. Una vez que tengamos un plan diseñado solo para usted, le proporcionaremos el enlace de descarga de la aplicación para que pueda comenzar de inmediato.',
  howWillIReceiveMyCustomizedMealAndWorkoutPlan:
    '¿Cómo recibiré mi plan de comidas y ejercicios personalizado?',
  appDownloadAndAccessInstructions:
    'Recibirá un enlace de descarga único que le llevará a la App Store para descargar la aplicación. Una vez instalada en su teléfono, inicie sesión con su correo electrónico. Tendrá acceso ilimitado a todas las funciones durante su periodo de suscripción. Si tiene dificultades para descargar o acceder a la aplicación, contáctenos en',
  planReceiveTime: '¿Cuándo recibiré mi plan de comidas y ejercicios personalizado?',
  planGenerationDetails:
    'Nuestros algoritmos inteligentes personalizan su plan de fitness según sus necesidades específicas. El enlace de descarga se generará justo después de su pago y el plan estará disponible tan pronto como descargue la aplicación usando su enlace único.',
  freeTrialQuestion: '¿Siempre ofrecemos pruebas gratuitas?',
  freeTrialInfo:
    'Tenga en cuenta que si ofrecemos prueba gratuita, esto se indicará explícitamente en la pantalla de precios antes de la compra. De lo contrario, adquirirá nuestra suscripción sin prueba gratuita.',
  billingQuestion: '¿Cómo me facturarán?',
  billingInfo:
    'Generalmente ofrecemos suscripciones con renovación automática. Según la opción que elija, su suscripción se renovará al final de cada periodo.',
  cancelSubscriptionQuestion: '¿Puedo cancelar mi suscripción?',
  cancelSubscriptionInfo:
    'Su suscripción se renueva automáticamente al final de cada periodo hasta que la cancele. Eliminar la aplicación no cancela su suscripción. Puede cancelar una prueba o suscripción desde la configuración de suscripciones en su iPhone o por correo electrónico.',
  noAccessQuestion: 'Ya no tengo acceso a mi suscripción, ¿qué ha pasado?',
  noAccessInfo:
    'A veces ofrecemos suscripciones no renovables que expiran tras el periodo contratado (1 mes, 3 meses o 6 meses). Una vez expirado, perderá el acceso. Si desea continuar, puede volver a comprarla en la aplicación o en la página web de Fit4Me en cualquier momento.',
  loginLabel:
    'Inicia sesión con tu correo electrónico para acceder a tu plan personal de pérdida de peso',
  email: 'Correo electrónico',
  logIn: 'Iniciar sesión',
  name: 'Nombre',
  gender: {
    label: 'Género',
    male: 'masculino',
    female: 'femenino',
  },
  dateOfBirth: 'Fecha de nacimiento',
  units: {
    label: 'Unidades',
    kg: 'kg',
    cm: 'cm',
    lbs: 'libras',
    in: 'pulgadas',
    m: 'metros',
    ft: 'pies',
  },
  startWeight: 'Peso inicial',
  height: 'Altura',
  doubleCheckAndRetry: 'Por favor, verifique e intente de nuevo',
  wrongEmail: 'Vaya, correo inválido',
  invalidEmailOrPassword: 'Vaya, correo o contraseña incorrectos',
  avatar: 'avatar',
  Profile: 'Perfil',
  Subscriptions: 'Suscripciones',
  loader: 'cargando',
  billingPeriod: 'Periodo de facturación',
  subscriptionPrice: 'Precio de suscripción',
  subscriptionCanceled: 'Su suscripción ha sido cancelada.',
  noFutureCharges: 'No se le cobrará en el futuro.',
  fullAccessUntilExpires: 'Tendrá acceso completo a Fit4Me hasta que su suscripción actual expire.',
  opps: '¡Vaya! <br/>Algo salió mal.',
  contactUsEmail: 'Contáctenos vía <br/><a href="mailto:{{companyEmail}}">{{companyEmail}}</a>',
  ok: 'OK',
  tooExpensive: 'Es demasiado caro',
  planNotSuitable: 'El plan no satisface mis necesidades',
  appQualityDisappointment: 'La calidad de la app no cumple con mis expectativas',
  notUsingButMayReturn: 'No estoy usando la app ahora, pero podría volver más tarde',
  goalsAchieved: 'Ya he alcanzado mis objetivos',
  technicalIssues: 'Ha habido problemas técnicos',
  planTooChallenging: 'Mi plan es demasiado exigente',
  avoidAutoRenewalFee: 'Quiero evitar la tarifa de renovación automática',
  forgotPassword: '¿Olvidó su contraseña?',
  resetPassword: 'Restablecer contraseña',
  labelForgot: 'Introduzca su correo para restablecer la contraseña',
  placeholderEmail: 'Introduzca su correo electrónico',
  recoveryEmailSentAt: 'Correo de recuperación enviado a las',
  pleaseCheckYourInbox: 'Por favor, revise su bandeja de entrada (y spam)',
  sendAgain: 'enviar de nuevo',
  changeEmail: 'cambiar correo',
  checkingYouEmail: 'Verificando tu correo electrónico',
  agreePrivacyPolicy:
    'Al continuar, aceptas nuestra <privacy>Política de privacidad</privacy> y nuestros <terms>Términos de uso</terms>',
  emailLogin: 'Inicio de sesión con correo electrónico',
  loginToFit4Me: 'Iniciar sesión en Fit4Me',
  enter5DigitCode: 'Introduce el código de 5 dígitos enviado a tu correo <bold>{{email}}</bold>',
  didNotReceiveTheCode: '¿No recibiste el código?',
  resendCode: 'Reenviar código',
  contactSupport: 'O puedes <bold>contactar con nuestro soporte</bold>',
  codeResent: '¡Código reenviado! Puedes solicitar otro en <bold>{{seconds}}s</bold>',
  emailDoesntMatch: 'El código de inicio de sesión no coincide',
  reCheck: 'Revisa el código o solicita uno nuevo.',
  payments: 'Pagos',
  manageSubscription: 'Gestionar suscripción',
  activeBadge: 'Activo',
  paymentMethod: 'Método de pago',
  cancelSubscriptionReason: '¿Por qué quieres cancelar?',
  nextChargeDate: 'Próxima fecha de cobro',
  lastChargeDate: 'Última fecha de cobro',
  accessUntil: 'Acceso hasta',
  renewSubscription: 'Renovar suscripción',
  addPaymentMethod: 'Añadir método de pago',
  noPaymentTitle: 'Sin métodos de pago',
  noPaymentDescription: 'Añade un método de pago para comenzar tu suscripción',
  canceledStatus: 'Cancelado',
  yourFeedbackMatters: '¡Tu opinión importa!',
  specialOffer: 'Espera mientras generamos una oferta especial.',
  limitedDeal: 'Oferta por tiempo limitado',
  offerSavings: 'Ofrecemos un 99 % de ahorro durante 6 semanas',
  keepWellness: '¡Mantén tu viaje de bienestar por solo el 1 % del costo regular!',
  dontMissChance:
    '{{name}}, no pierdas la oportunidad de continuar con la guía nutricional personalizada de Simple. Después del período de ahorro de 3 meses, se reanuda automáticamente la facturación trimestral estándar (79,20 $).',
  keepPremium: 'Mantener Premium',
  cancelSubscriptionBtn: 'Cancelar suscripción',
  footerText:
    'Recuerda: puedes cancelar en cualquier momento antes del 30 de abril de 2025 sin cargos de renovación. Tu tarifa con 99 % de descuento se aplica durante las 12 semanas completas. Si decides continuar, tu membresía se renovará automáticamente a la tarifa trimestral regular de 79,20 $ después de que finalice el período promocional. No ofrecemos reembolsos por tiempo de suscripción parcialmente utilizado. Para gestionar o cancelar tu membresía, simplemente visita tu página de Gestión de Suscripción.',
  prosList: {
    analyzed: 'Perfil analizado',
    noChange: 'Sin cambios en tu ciclo de facturación actual',
    after: 'Después de 12 semanas, tu suscripción es de 79,20 $ trimestrales.',
  },
  gotIt: 'Ok, entendido',
  weCanceled: 'Hemos cancelado tu suscripción',
  yourSubscriptionIsCanceled:
    'Tu suscripción a Fit4Me está cancelada. No se aplicarán más cargos. Seguirás teniendo acceso completo hasta el',
  supportForEditional: 'para más información',
  contact: 'Contáctenos',
  id: 'ID',
  'My account': 'Mi cuenta',
  'My Subscriptions': 'Mis suscripciones',
  Support: 'Soporte',
  FAQ: 'Preguntas frecuentes',
  'Cancel Subscription': 'Cancelar suscripción',
  'Money-Back Policy': 'Política de reembolso',
  'Privacy Policy': 'Política de privacidad',
  'Terms of Use': 'Términos de uso',
  'Meals Recommendations': 'Recomendaciones de comidas',
  'Contact Us': 'Contáctanos',
}
